class RitmoHeader extends HTMLElement {
  constructor() {
    super();
    // Screen size breakpoints
    this.isMediumScreen = window.innerWidth < 990 && window.innerWidth >= 750;
    this.isSmallScreen = window.innerWidth < 750;
    
    // Get background color and apply no-border classes if a custom background is set
    this.backgroundColor = this.style.getPropertyValue('--ritmo-header-background-color');
    if (this.backgroundColor && this.backgroundColor !== '#FFFFFF' && this.backgroundColor !== '') {
      this.classList.add('ritmo-header--no-border');
    }
    
    // Bind methods
    this.handleResize = this.handleResize.bind(this);

    // Add event listener for window resize
    window.addEventListener('resize', this.handleResize);
  }

  connectedCallback() {
    this.setupHeaderLayout();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    const wasMediumScreen = this.isMediumScreen;
    const wasSmallScreen = this.isSmallScreen;
    
    this.isMediumScreen = window.innerWidth < 990 && window.innerWidth >= 750;
    this.isSmallScreen = window.innerWidth < 750;
    
    // Only update layout if screen size category changed
    if (wasMediumScreen !== this.isMediumScreen || wasSmallScreen !== this.isSmallScreen) {
      this.setupHeaderLayout();
    }
  }

  setupHeaderLayout() {
    const centerMenu = this.querySelector('.ritmo-header__center');
    const stackedRow = this.querySelector('.ritmo-header__stacked-row');
    const tabsContainer = this.querySelector('.ritmo-header__tabs-container');
    
    if (!centerMenu || !stackedRow || !tabsContainer) return;

    // Set styles based on screen size
    if (this.isSmallScreen || this.isMediumScreen) {
      // On small/medium screens, move center menu to stacked row
      centerMenu.classList.add('ritmo-header__center--desktop-only');
      stackedRow.style.display = 'flex';
    } else {
      // On larger screens, show center menu in main row
      centerMenu.classList.remove('ritmo-header__center--desktop-only');
      
      // Hide stacked row if not using stacked layout
      if (!this.hasAttribute('data-stacked')) {
        stackedRow.style.display = 'none';
      }
    }

    // Apply header height based on screen size
    const headerHeight = this.isSmallScreen ? '48px' : '60px';
    const paddingHorizontal = this.isSmallScreen ? '16px' : '32px';

    // Update document styles - these will cascade to our component
    document.documentElement.style.setProperty('--header-height', headerHeight);
    document.documentElement.style.setProperty('--header-padding-horizontal', paddingHorizontal);
  }
}

customElements.define('ritmo-header', RitmoHeader);
